export default __webpack_public_path__ + "static/banner-img1-c927d6573879c4191c64150488368a45.png";